
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import './carouselSection2.css'

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import slides from './mock.json';
import { CURRENT_URL } from '../../config/runtimeConfig';


function CarouselSection2() {
    const pagination = {
        clickable: true,
        // renderBullet: function (index, className) {
        //   return '<span class="' + className + '">' + (index + 1) + '</span>';
        // },
    };

    return (
        <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={20}
            slidesPerView={1}
            loop={true}
            speed={500}   //speed={6500}
            navigation={true}
            autoplay={{
                delay: 1000,  //  delay: 0,
                disableOnInteraction: false,
            }}
            breakpoints={{
                370: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                500: {
                    slidesPerView: 2,
                    spaceBetween: 5,
                },
                700: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            }}
            className="swiper-section-2"
        >
            {
                slides.map(slide => (
                    <SwiperSlide key={slide.index}>
                        <img src={`${CURRENT_URL}/slides/${slide.image}`} />
                    </SwiperSlide>
                ))
            }
        </Swiper>
    )
}

export default CarouselSection2
